import { useApi, useToaster } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import type { CreateExpertPlanRequest } from "@shopexperts/legacy-api";
import { describeBillingApiError } from "@/app/composables/expert-billing/billingOptionForm";

export function useCreateExpertPlan() {
  const api = useApi();
  const toaster = useToaster();
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isPending, error } = useMutation({
    mutationKey: ["admin", "expert-plans", "create"],
    mutationFn: (body: CreateExpertPlanRequest) => {
      return api.admin.expertSubscriptions.createPlan({ body });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin", "expert-plans"] });
      toaster.create({
        title: "Plan created",
        type: "success",
      });
    },
    onError: (err: Error) => {
      toaster.create({
        title: "Failed to create plan",
        description: describeBillingApiError(err),
        type: "error",
      });
      console.error("[useCreateExpertPlan] Error:", err);
    },
  });

  return { mutate, mutateAsync, isPending, error };
}

export default useCreateExpertPlan;
